<template>
        <router-view ></router-view>
</template>

<script>
export default {
    name: "outBox",
}
</script>

<style scoped>

</style>
